



import { Component, Vue } from 'vue-property-decorator';

import NumberPicker, { NumberPickerColor } from '@/shared/components/number-picker.component.vue';

@Component({
    components: {
        NumberPicker,
    },
})

export default class NumberPickerPartial extends Vue {
  private NumberPickerColor = NumberPickerColor;
}
